import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { FormGroup, Label } from './styles/common';
import { reactSelectStyles } from './reactSelectStyles';

// v2 of formInputs/FormInputSelectSearchable — forked (not edited in place)
// because the v1 original is shared with Cauzioni's StepGaranzia.jsx via
// Commercial/components/parts/InputByType.jsx.
function FormInputSelectSearchable({
  label,
  options,
  value,
  error,
  valid,
  onChange,
  placeholder = '',
  optionLabel = 'name',
  optionValue = 'id',
  isClearable = true,
  loadingMessage = 'Caricamento...',
  noOptionsMessage = 'Nessuna opzione trovata!',
  formGroupClassName = '',
}) {
  const [prepOptions, setPrepOptions] = useState([]);

  useEffect(() => {
    setPrepOptions(options.map((i) => ({ value: i[optionValue], label: i[optionLabel] })));
  }, [options, optionLabel, optionValue]);

  const selectedValue = prepOptions.find((opt) => opt.value === value) || null;

  return (
    <FormGroup className={formGroupClassName}>
      {label && <Label>{label}</Label>}
      <ReactSelect
        options={prepOptions}
        defaultOptions
        isSearchable
        placeholder={placeholder}
        value={selectedValue}
        onChange={(val) => {
          onChange(val ? val.value : '');
        }}
        loadingMessage={() => loadingMessage}
        isClearable={isClearable}
        noOptionsMessage={() => noOptionsMessage}
        styles={reactSelectStyles({ error: Boolean(error), valid })}
      />
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </FormGroup>
  );
}

export default FormInputSelectSearchable;
